import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = ["Select Video to Test", "Upload", "Test Settings", "Get Views!"];
type AddTestStepper = {
  activeStep: number;
};
export default function AddTestStepper(fn: AddTestStepper) {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        activeStep={fn.activeStep}
        sx={{ paddingX: 0, marginX: 0 }}
        alternativeLabel
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
